import { render, staticRenderFns } from "./CloseCdpModal.vue?vue&type=template&id=8e968400&scoped=true&"
import script from "./CloseCdpModal.vue?vue&type=script&lang=js&"
export * from "./CloseCdpModal.vue?vue&type=script&lang=js&"
import style0 from "./CloseCdpModal.vue?vue&type=style&index=0&id=8e968400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e968400",
  null
  
)

export default component.exports